import { render, staticRenderFns } from "./ModalSubtitle.vue?vue&type=template&id=391f4809&"
import script from "./ModalSubtitle.vue?vue&type=script&lang=js&"
export * from "./ModalSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports